import {
  Box,
  Button,
  Center,
  Group,
  Select,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core'
import { modals } from '@mantine/modals'

import { Icons } from 'src/common/components'

import { useSwitchOrganization } from '../../hooks/useSwitchOrganization.hook'

const SwitchOrganizationModal = ({ personOrganizations, personId }: any) => {
  const { isChanging, form, onSubmit, newListOrganizations } =
    useSwitchOrganization(personOrganizations, personId)

  return (
    <Box>
      <Stack align="center" justify="center" my="md">
        <ThemeIcon size={80} radius="xl" variant="light">
          <Icons.Reload height="50" width="50" />
        </ThemeIcon>
        <Title order={3} c="primary">
          Switch Organization
        </Title>
      </Stack>
      <Center mb="xs">
        {newListOrganizations.length === 0 && (
          <Text size="md" ta="center">
            The record you’re trying to open belongs to another organization.
            But you don't have access to these organization. Sorry :(
          </Text>
        )}
        {newListOrganizations.length === 1 && (
          <Text size="md" ta="center">
            The record you’re trying to open belongs to{' '}
            <Text size="lg" span fw="bold">
              {newListOrganizations[0].label}
            </Text>{' '}
            organization. Are you sure you want to Switch Organizations?
          </Text>
        )}
        {newListOrganizations.length === 2 && (
          <Text size="md" ta="center">
            The record you’re trying to open belongs to another organization.
            Are you sure you want to Switch Organizations?
          </Text>
        )}
      </Center>

      <form
        onSubmit={(e) => {
          e.preventDefault()
          onSubmit()
        }}
      >
        {newListOrganizations.length > 1 && (
          <Select
            key={form.key('newOrganization')}
            label="Organization"
            placeholder="Select an organization"
            data={newListOrganizations}
            {...form.getInputProps('newOrganization')}
            withAsterisk
            mb="md"
          />
        )}

        {newListOrganizations.length > 0 && (
          <Group justify="space-between">
            <Button onClick={() => modals.closeAll()} variant="outline">
              No, Stay Here
            </Button>
            <Button variant="filled" loading={isChanging} type="submit">
              Yes, Switch
            </Button>
          </Group>
        )}
      </form>
    </Box>
  )
}

export const switchOrganizationModal = (
  personOrganizations: any,
  personId: any,
) =>
  modals.open({
    centered: true,
    children: (
      <SwitchOrganizationModal
        personOrganizations={personOrganizations}
        personId={personId}
      />
    ),
    size: 'md',
    radius: 'md',
    withCloseButton: false,
  })
